import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { connect } from '../../../common/react-redux';
import { updateItem } from '../../../building/api/items';
import { updateStimulus } from '../../../building/api/stimuli';
import { clearModifications, clearTemporaryBankItem, changeItemTitle, changeQuizEntryPoints } from '../../../common/actions/modifications';
import { setPendingAdditionTagAssociations, setPendingDeletionTagAssociations, setTagInput } from '../../../common/actions/tagAssociations';
import BankEntryRecord from '../../../common/records/BankEntry';
import BankRecord from '../../../common/records/Bank';
import { getBankEntry, cloneBankEntry, createEntryAndBankEntry } from '../../../banks/api/bankEntries';
import { getBank } from '../../../banks/api/banks';
import { createTagAssociations, deleteTagAssociations } from '../../../banks/api/tagAssociations';
import { BankEntry as BankEntryPresenter } from './presenter';
import { featureOn } from '../../../common/util/featureCheck';
import { set as setUI } from '../../../common/actions/ui';
import { openModal } from '../../../common/actions/modal';
import { SHOULD_CLONE_ITEM, TEMPORARY_BANK_ENTRY_ID } from '@instructure/quiz-common';
function mapStateToProps(state, props) {
  var tempBankEntry = state.getIn(['modifications', 'bankEntries', TEMPORARY_BANK_ENTRY_ID]);
  var bankEntry;
  if (tempBankEntry) {
    bankEntry = new BankEntryRecord(tempBankEntry);
  } else {
    bankEntry = new BankEntryRecord(state.getIn(['bankEntries', props.bankEntryId]));
  }
  var bank = new BankRecord(state.getIn(['banks', props.bankId]));
  var shouldClone = state.getIn(['ui', SHOULD_CLONE_ITEM]) || false;
  var entry = bankEntry.getEntry();
  var entryId = entry ? entry.id : null;
  return {
    bank: bank,
    bankEntry: bankEntry,
    entry: entry,
    shouldClone: shouldClone,
    pendingAdditionTags: state.getIn(['tagAssociations', 'pendingAddition', bankEntry.entryType, entryId]),
    pendingDeletionTags: state.getIn(['tagAssociations', 'pendingDeletion', bankEntry.entryType, entryId]),
    tagAssociations: state.getIn(['tagAssociations', bankEntry.entryType, entryId]),
    tagInput: state.getIn(['tagAssociations', 'tagInput', bankEntry.entryType, entryId]),
    useBankTags: featureOn('item_bank_tagging')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setPendingAdditionTagAssociations: bindActionCreators(setPendingAdditionTagAssociations, dispatch),
    setPendingDeletionTagAssociations: bindActionCreators(setPendingDeletionTagAssociations, dispatch),
    setTagInput: bindActionCreators(setTagInput, dispatch),
    createTagAssociations: bindActionCreators(createTagAssociations, dispatch),
    deleteTagAssociations: bindActionCreators(deleteTagAssociations, dispatch),
    getBankEntry: bindActionCreators(getBankEntry, dispatch),
    getBank: bindActionCreators(getBank, dispatch),
    updateItem: bindActionCreators(updateItem, dispatch),
    updateStimulus: bindActionCreators(updateStimulus, dispatch),
    setShouldClone: bindActionCreators(partial(setUI, SHOULD_CLONE_ITEM), dispatch),
    changeItemTitle: bindActionCreators(changeItemTitle, dispatch),
    changeQuizEntryPoints: bindActionCreators(changeQuizEntryPoints, dispatch),
    cloneBankEntry: bindActionCreators(cloneBankEntry, dispatch),
    createEntryAndBankEntry: bindActionCreators(createEntryAndBankEntry, dispatch),
    clearModifications: bindActionCreators(clearModifications, dispatch),
    clearTemporaryBankItem: bindActionCreators(clearTemporaryBankItem, dispatch),
    setUi: bindActionCreators(setUI, dispatch),
    openModal: bindActionCreators(openModal, dispatch)
  };
}
export var BankEntry = connect(mapStateToProps, mapDispatchToProps)(BankEntryPresenter);
export default BankEntry;